import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import { executeQuery } from "../../requests/executeQuery";
import { SELLERS_LIST, SELLERS_LIST_COUNT } from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_SELLERS } from '../Graphql/Queries/SellersQuery';
import { GET_CONTACT_SELLERS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';


const limit = 50;

export default class SellerList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: null,
			totalCount: null,
			error: null,
			isBusy: null,
		};
		this.client = null;
	}

	componentDidMount() {
		if (this.client) {
			this.fetch(this.props.location.query);
		}
	}
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field,
                    order: order
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field,
                order: order
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }
	fetch(q) {
		this.setState({ isBusy: true });

		const query = { ...q };
		const options = filter(query, 'sellers');
		options.param.limit = limit;
		options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

		var pageParams = {
			page: query.page ? Number(query.page) : 1,
			pageSize: limit
		}
		
		const token = localStorage.getItem('authToken');
		const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 
		// Promise.all([
		// 	executeQuery({ queryName: SELLERS_LIST, options: options }),
		// 	executeQuery({ queryName: SELLERS_LIST_COUNT, options: options })
		// ]).then(res => {
		// 	this.setState({
		// 		items: res[0].data,
		// 		totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
		// 		error: res[0].success ? null : res[0].message,
		// 		isBusy: null,
		// 	});
		// });

		// if (this.client && token) {
		// 	this.client.query({ query: GET_SELLERS, variables: { pageOptions: pageParams } })
		if (this.client) {
            // this.client.query({
            //     query: GET_CONTACT_SELLERS_LIST_QUERY, variables: { type: "Seller",pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions }, fetchPolicy: "no-cache",
            //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // })
			fetchData(GET_CONTACT_SELLERS_LIST_QUERY, {type: "Seller",pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions})
			.then(res => {
					this.setState({
						items: res.data.getContacts.data,
						totalCount: res.data.getContacts.totalCount,
						error: null,
						isBusy: null,
					});
				})
				.catch(err => {
					this.setState({
						error: err.message,
						isBusy: null,
					});
				});
		}
		
		
	}

	componentDidUpdate(prevProps) {
		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
			this.fetch(this.props.location.query);
		}
	}
	render() {
		const query = this.props.location.query;
		const itemsToDisplay = this.state.items ? this.state.items.slice(0, 50) : [];//newly added
		const columns = [
			{
				name: 'View',
				columnStyle: { width: 70 },
				render: (el) => (
					<Link to={{ pathname: `${arc.path.base}seller/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
				),
			},
			{
				code: 'status',
				name: 'Status',
				render: (el) => el.status,
			}, {
				name: 'Seller',
				subColumns: [{
					code: 'first_name',
					name: 'First Name',
					render: (el) => el.first_name,
				}, {
					code: 'last_name',
					name: 'Last Name',
					render: (el) => el.last_name,
				}],
				headerStyle: {
					minWidth: 218,
					justifyContent: 'center'
				},
			}, {
				code: 'email',
				name: 'email',
				render: (el) => el.email ? <a href={`mailto:${el.email}`}>{el.email}</a> : null,
			}, {
				code: 'phone',
				name: 'phone',
				columnStyle: {
					minWidth: 132,
				},
				render: (el) => el.phone ?
					<a href={`tel:${el.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.phone}</a> : null,
			}, {
				code: 'company_name',
				name: 'Company Name',
				render: (el) => el.company_name,
			}
		];

		return (
			<ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
						this.fetch(this.props.location.query);
					}
					return (
						<div className='SellerList' data-is-busy={this.state.isBusy}>
							<div className='page-rounded-corner-container'>
								<div className='page-header-container list'>
									<div className='page-header list'>
										<div className='page-title'>Sellers</div>
										<LinkComp to={`${arc.path.base}seller`}>
											<div className="button-new plus positive">
												<Icon svg={plus} />
											</div>
										</LinkComp>
									</div>
									<div className='line' />
								</div>
							</div>
							<div className='page-body-container'>
								<SortTable columns={columns} items={this.state.items} query={query} hasSubColumns={true} classNameModifier='sellers' />
								<ListResults query={this.props.location.query} pathname={this.props.location.pathname} 
								error={this.state.error}
								// totalCount={this.state.totalCount} 
								// itemCount={this.state.items ? this.state.items.length : false} 
								totalCount={this.state.totalCount}
                                itemCount={itemsToDisplay.length}
								limit={limit} />
							</div>
						</div>
					)
				}}

			</ApolloConsumer>
		);
	}
}
